import { render, staticRenderFns } from "./FlagComponent.vue?vue&type=template&id=43ef4e48&"
import script from "./FlagComponent.vue?vue&type=script&lang=ts&"
export * from "./FlagComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports